import React, { ReactNode, useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { Badge, Button, Popover } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Catcher } from '../';
import cx from 'classnames';
import { useUiLanguage, useUiServerNotificationsCount, useUiServerNotificationsStatus } from '../../hooks';
import { getServerNotificationsCountNew } from '../../middleware';
import { tP } from '../../translate';
import { Notifications } from './Components';
import Styles from './m_styles.less';

export const ServerNotificationNew: React.FC = observer(() => {
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const languageId = useUiLanguage();
    const isConnectServer = useUiServerNotificationsStatus();
    const { countUnRead } = useUiServerNotificationsCount();

    async function firstStart() {
        const isHasUnRead = await getServerNotificationsCountNew();
        if (isHasUnRead) {
            setIsPopupOpen(true);
        }
    }

    useEffect(() => {
        firstStart();
    }, []);
    const onOpenChange = (isOpen: boolean): void => {
        setIsPopupOpen(isOpen);
    };

    const PopoverTitle = (): ReactNode => {
        return (
            <div className={Styles.popoverTitle}>
                <h3 className={cx(Styles.titleItem, Styles.title)}>{tP('Notifications')}</h3>
                <div className={Styles.titleItem}>
                    <Badge
                        count={`${countUnRead}`}
                        className={cx({
                            [Styles.badgeStatusOk]: !countUnRead,
                            [Styles.badgeStatusError]: !!countUnRead,
                        })}
                    />
                </div>
            </div>
        );
    };

    return (
        <Catcher>
            <div className={Styles.main}>
                <Badge count={countUnRead}>
                    <Popover
                        placement="bottom"
                        title={PopoverTitle}
                        content={isPopupOpen ? <Notifications /> : null}
                        trigger="click"
                        onOpenChange={onOpenChange}
                        open={isPopupOpen}
                    >
                        <Button
                            type="text"
                            icon={
                                <ExclamationCircleOutlined
                                    className={cx(Styles.icon, {
                                        [Styles.badStatusIcon]: !isConnectServer,
                                        [Styles.isActiveIcon]: !!countUnRead && isConnectServer,
                                    })}
                                />
                            }
                        />
                    </Popover>
                </Badge>
            </div>
        </Catcher>
    );
});
